









































































import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store";
import { UserModel } from "@/models/usermodel";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      user: "getUserProfile",
    }),
  },
})
export default class Header extends Vue {
  @Prop() public isThemesPink: boolean;
  public user: UserModel;
  public switch1: boolean = false;

  public handleThemes(e: any) {
    const isTheme = e;
    this.$emit("change-theme", isTheme);
  }

  public logout() {
    window.localStorage.removeItem("token");
    store.dispatch("logout");
    this.$router.replace("login");
  }
}
